import { Component, createRef } from "react";




import { 
  Card,
  Section,
} from 'react-bulma-components';
import axios from "axios";
import { baseUrl } from "@ora/recursos/src/helpers/Url";


class MediaColumnFicha extends Component{
  state = {
    data: null
  }
  // constructor (props) {
  //   super(props)
  // }
  renderDetalle = () => {
    if ((typeof this.props.detalle).toString().toLocaleLowerCase() === 'object') {
      if (this.props.detalle) {
        return this.props.detalle
      } else 
        return ''
    } else if ((typeof this.props.detalle).toString().toLocaleLowerCase() === 'string'){
      return (<p>{ this.props.detalle }</p>)
    }
    return ''
  }
  render () {
    return (
      <article className="media">
      <div className="media-content">
          <div className="columns content">
            <div className="column is-one-third">
              <p className="media-meta">
                <strong>{ this.props.columna }</strong>
              </p>
            </div>
            <div className="column">
              { this.renderDetalle() }
            </div>
          </div>{/**/}
        </div>
      </article>
    )
  }
}

export default MediaColumnFicha